import { useMemo } from 'react';
import { styled } from 'goober';
import { useTranslation } from 'react-i18next';

import { LoadableList } from '@/components/loadable-list/loadable-list';
import { usePendingProjectRequests } from '@/features/projects/projects-list/use-pending-project-requests.query';

import { SKELETON_COUNT } from '../constants';
import { EmptyState } from '../components/empty-state';
import { PendingRequestCardSkeleton } from '../skeletons/pending-request-card-skeleton';
import { PendingRequestCard } from './pending-request-card';

export const PendingRequestsContent = () => {
  const { t } = useTranslation('notification');
  const {
    data: pendingRequestsData,
    fetchNextPage,
    hasNextPage,
    isLoading,
  } = usePendingProjectRequests();

  const pendingRequests = useMemo(() => {
    return pendingRequestsData?.pages.flat() ?? [];
  }, [pendingRequestsData]);

  const handleLoadMore = async () => {
    if (hasNextPage) {
      await fetchNextPage();
    }
  };

  if (isLoading && pendingRequests.length === 0) {
    return (
      <List hasMore={false} onLoadMore={() => {}}>
        {Array.from({ length: SKELETON_COUNT.PENDING_REQUESTS_INITIAL }).map(
          (_, index) => (
            <PendingRequestCardSkeleton key={`skeleton-${index}`} />
          ),
        )}
      </List>
    );
  }

  if (pendingRequests.length === 0) {
    return <EmptyState message={t`noPendingRequests`} />;
  }

  return (
    <List hasMore={hasNextPage ?? false} onLoadMore={handleLoadMore}>
      {pendingRequests.map(request => (
        <PendingRequestCard key={request.id} request={request} />
      ))}
      {isLoading &&
        Array.from({ length: SKELETON_COUNT.PENDING_REQUESTS_LOADING }).map(
          (_, index) => (
            <PendingRequestCardSkeleton key={`loading-skeleton-${index}`} />
          ),
        )}
    </List>
  );
};

const List = styled(LoadableList)`
  gap: 12px;
  padding: 12px 20px;
`;
